import React from "react";

function SindhEntryToPrisoner() {
  return (
    <div className="bg-sindh-entry-to-prisoner py-5">
      <div className="container">
        <div>
          <h2 className="text-h-black text-light">Upon Entering the Prison</h2>
        </div>

        <div className="row row-cols-1 row-cols-md-3 g-4 my-5">
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “When you first go in, they ask you to take off your clothes.
                  As B-class prisoners, we did not have to take our clothes off,
                  but we were on the side and they told the rest to undress.
                  They made them lie down and started beating them. They beat
                  them at the gate and made them run naked.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Malik Qureshi</small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “They want to strip a person of all respect. I was beaten with
                  sticks on entering the jail. They put your legs against the
                  wall and do 'cheera' [torture technique]. This happened to me
                  as well. They didn’t do the full which makes a person
                  impotent.They also tied you upside down and beat you with a
                  whip.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Malik Qureshi</small>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="card h-100">
              <div className="card-body">
                <h3 className="card-title text-hp-orange">
                  “I had never seen jail before, and I was made to lie between a
                  lot of people, and they were very dangerous people. It was the
                  first time I was seeing jail and I was sleeping next to them.
                  If I was to get up and move, and they turned in their sleep,
                  then my spot would be gone and I could not get it back.”
                </h3>
              </div>
              <div className="card-footer">
                <small className="text-muted">- Malik Qureshi</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SindhEntryToPrisoner;
